import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type { Role, RoleCreatePayload, RoleUpdatePayload } from '@/common-types';
import type { RoleResponse, RolesResponse } from '@/types/application/models/service/role-model-responses';

/**
 * List all roles
 */
export async function listRoles(): Promise<Role[]> {
  const response = await fetchApi<RolesResponse>(API_ENDPOINTS.ROLES);
  return response.data.roles;
}

/**
 * Get role by ID
 */
export async function getRole(roleId: string): Promise<Role> {
  const response = await fetchApi<RoleResponse>(API_ENDPOINTS.ROLE_BY_ID(roleId));
  return response.data.role;
}

/**
 * Create role
 */
export async function createRole(payload: RoleCreatePayload): Promise<Role> {
  const response = await fetchApi<RoleResponse>(API_ENDPOINTS.ROLES, {
    method: 'POST',
    body: payload,
  });
  return response.data.role;
}

/**
 * Update role
 */
export async function updateRole(roleId: string, payload: RoleUpdatePayload): Promise<Role> {
  const response = await fetchApi<RoleResponse>(API_ENDPOINTS.ROLE_BY_ID(roleId), {
    method: 'PATCH',
    body: payload,
  });
  return response.data.role;
}

/**
 * Delete role
 */
export async function deleteRole(roleId: string): Promise<void> {
  await fetchApi(API_ENDPOINTS.ROLE_BY_ID(roleId), {
    method: 'DELETE',
  });
}

export default {
  listRoles,
  getRole,
  createRole,
  updateRole,
  deleteRole,
};




